import { render } from "./add-edit-director-modal.html?vue&type=template&id=3df0f50c&scoped=true&ts=true&external"
import script from "./add-edit-director-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-director-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-director-modal.scss?vue&type=style&index=0&id=3df0f50c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df0f50c"]])

export default __exports__